export default __webpack_public_path__ + "static/media/editItem-img.eae2bef9.svg";